export class Csp5050Class {
    UserNam: string;
}
